<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc">
<header><h1 class="fmtitle" epub:type="title"><span epub:type="pagebreak" id="page_vii" title="vii">Contents</span></h1></header>
<p class="toc"><a href="#/xhtml/08_Introduction">Introduction</a></p>
<p class="toc"><span href="#/xhtml/11_Chapter01" title="Link target outside of Sample">Harriott Horry</span></p>
<p class="toc1"><span href="#/xhtml/11_Chapter01#ch1_1" title="Link target outside of Sample">List of the Recipes</span></p>
<p class="toc1a"><span href="#/xhtml/11_Chapter01#ch1_2" title="Link target outside of Sample">The Recipes</span></p>
<p class="toc"><span href="#/xhtml/12_Index01" title="Link target outside of Sample">Index</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Contents.vue?3597f239